import { FC } from 'react';

import cls from './EmptyState.module.scss';

type EmptyStateProps = {
  text?: string;
};

export const EmptyState: FC<EmptyStateProps> = ({ text = 'Данные отсутствуют' }) => {
  return <div className={cls.wrapper}>{text}</div>;
};
